import React, { useState, useEffect,useLayoutEffect } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import { BarCodeScanner } from 'expo-barcode-scanner';
import * as ScreenOrientation from 'expo-screen-orientation';
import { useIsFocused } from '@react-navigation/native';

import styles from './styles';

const BarCodePay = ({ navigation }) => {
    const [hasPermission, setHasPermission] = useState(null);
    const [scanned, setScanned] = useState(false);
    const isFocused = useIsFocused();

    useEffect(() => {
        (async () => {
            const { status } = await BarCodeScanner.requestPermissionsAsync();
            setHasPermission(status === 'granted');
        })();
    }, [isFocused]);

    useEffect(() => {
        orientation();
    }, []);

    async function orientation(){
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE_RIGHT);
    }

    const handleBarCodeScanned = async ({ type, data }) => {
        setScanned(true);
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
        navigation.navigate('BarCodeConfirmPay');
    };

    if (hasPermission === null) {
        return <Text>Precisamos do acesso a câmera.</Text>;
    }
    if (hasPermission === false) {
        return <Text>Sem acesso câmera.</Text>;
    }

    async function goBack(){
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
        navigation.goBack();
    }

    async function toTypeBarCode(){
        await ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.PORTRAIT_UP);
        navigation.navigate('BarCodeConfirmPay');
    }

    return (
        <View style={styles.container}>
            <MaterialIcons
                name="keyboard-arrow-left"
                size={30}
                color="#fff"
                style={styles.iconBackPage}
                onPress={goBack}
            />

            <Text style={styles.textInfoQrCode}>Aponte a câmera ao leitor</Text>
            <BarCodeScanner
                onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
                style={styles.contentQrCode}
            />

            <TouchableOpacity style={styles.btnBarCode} onPress={toTypeBarCode}>
                <Text style={styles.textBtnCode}>Digitar código</Text>
            </TouchableOpacity>

        </View>
    );
}

export default BarCodePay;